
import { React, useState, useEffect } from 'react'
import ErrorLogs from '../../../components/ErrorBoundary/errorlogs'
import { useAuthState } from '../../../components/AuthProvider'
import { useGeoState } from '../../../components/GeoProvider'
import {startDate,endDate,endDatePublic} from '../dates'
import { useGeoFetch } from '../../../components/GeoProvider'
import TrendCharts from '../TrendCharts'
import getThresholdValueAqi from '../../../utils/getThresholdValueAqi'
import ErrorMessage from '../../../components/Layout/ErrorMessage'

const TrendChart = ({ geo_type,geo_id,data_type }) => {
    const [getAllergyData, setAllergyData] = useState()
    const [getStaticData, setStaticData] = useState()
    const [getAqiPublicData, setAqiPublicData] = useState()
    const { user } = useAuthState()
  const [errorCode, setErrorCode] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
  const [isAlLoading,setIsAlLoading] =useState(false)
  const [isAqLoading,setIsAqLoading] =useState(false)
    const {
    diseaseSelected
  } = useGeoState()

  const { data: staticData, error: staticDataError } = useGeoFetch(
    startDate,
    endDate,
    'allergiesstaticdata',
    `?table_type=ALLERGY&disease_id=${diseaseSelected}`
  )

  useEffect(() => {
    if (staticData !== null && staticData !== undefined) {
      if (staticData.response_code === 200) {
        ErrorLogs({
          message_type: 'Activity',
          error_details: 'Dashboard access success',
          user: user,
        })
        setStaticData(staticData.response_data)
      } else {
        setStaticData(null)
        setErrorCode(staticData.response_code)
        setErrorMessage(staticData.response_message)
        setErrorSubject(staticData.response_subject)
        seterrorOccured(true)
      }
    }
  }, [staticData])

  const { data: statesData, error: MapError } = useGeoFetch(
    startDate,
    endDate,
    'allergiesairqualitytrend',
    `${geo_type}/${diseaseSelected}/?geo_id=${geo_id}`
  )

  useEffect(() => {
    setIsAlLoading(true)
    if (statesData !== null && statesData !== undefined) {
      if (statesData.response_code === 200) {
        ErrorLogs({
          message_type: 'Activity',
          error_details: 'Dashboard access success',
          user: user,
        })
        setAllergyData(statesData.response_data)
      } else {
        setAllergyData(null)
        setErrorCode(statesData.response_code)
        setErrorMessage(statesData.response_message)
        setErrorSubject(statesData.response_subject)
        seterrorOccured(true)
      }
      setIsAlLoading(false)
    }
  }, [statesData])

  const { data: aqiData, error: aqiError } = useGeoFetch(
    startDate,
    endDatePublic,
    'allergiesairqualitypublictrend',
    `${geo_type}/${geo_id}`
  )

  useEffect(() => {
    setIsAqLoading(true)
    if (aqiData !== null && aqiData !== undefined) {
      if (aqiData.response_code === 200) {
        ErrorLogs({
          message_type: 'Activity',
          error_details: 'Dashboard access success',
          user: user,
        })
        setAqiPublicData(aqiData.response_data)
      } else {
        setAqiPublicData(null)
        setErrorCode(aqiData.response_code)
        setErrorMessage(aqiData.response_message)
        setErrorSubject(aqiData.response_subject)
        seterrorOccured(true)
      }
      setIsAqLoading(false)
    }
  }, [aqiData])

  if (
    aqiError||
    MapError ||
    errorOccured ||
    staticDataError 
  ) {
    return (
      <ErrorMessage
        errorCode={errorCode}
        errorMessage={errorMessage}
        errorSubject={errorSubject}
        errorDetails={errorMessage}
      />
    )
  }

  //For Allergy Trend Chart
const dataCategory =(getStaticData!==undefined&&
getStaticData.map((season) => {
  return {
    value: season.data_id,
    label: season.display_value,
  }
}))
  let chartData=[]
  getAllergyData!==undefined&&getAllergyData.map((data_val) => {
    let jsonData=JSON.parse(data_val.json_value)
    let lineData=[]
    let disease_id=""
    let disease_name=""
    jsonData.map((value)=>{
        lineData.push([Date.parse(new Date(value.week_ending)),
        parseInt(value.data_value===null?0:value.data_value)])
        disease_id=value.disease_id
        disease_name=value.disease_name
    })
    let obj={
        "disease_id": disease_id,
        "season": disease_name,
        "geo_type": geo_id,
        "json_value": lineData
    }
    chartData.push(obj)
    
  })
//For Allergy Trend Chart

//For AQI Public Data Trend Chart
let pollutantChartData=[]
let pollenChartData=[]
let dataCategoryPollen=[]
let dataCategoryPollutant=[]
getAqiPublicData!==undefined&&getAqiPublicData.map((data_val) => {
  if(data_val.data_type.toLowerCase()==='air_quality')
    {
      let dobj={label:data_val.parameter,
                value:data_val.parameter
              }
      dataCategoryPollutant.push(dobj)
      let jsonData=JSON.parse(data_val.json_value)
      let lineData=[]
      let data_type=""
      let parameter=""
      jsonData.map((value)=>{
        lineData.push(
          {
            y: (value.actual_value===null?0:value.actual_value),
            marker:value.week_ending===value.date? { 
              enabled:true,
              radius:6,
              fillColor: getThresholdValueAqi(value.threshold_level).color,
              lineWidth: 2,
              lineColor: 'black'
             }:{enabled:true,
              radius:3,
              fillColor: getThresholdValueAqi(value.threshold_level).color,
              lineWidth: 1,
              lineColor: 'black'},
            x:  new Date(value.date).getTime(),
            enableShow: value.week_ending===value.date?true:false ,
          } 
        )
        data_type=value.data_type
        parameter=value.parameter
      })
      let obj={
        "disease_id": data_type,
        "season": parameter,
        "geo_type": geo_id,
        "json_value": lineData
      }
      pollutantChartData.push(obj)
    }
  else{
      let dobj={label:data_val.parameter,
                value:data_val.parameter
                }
    dataCategoryPollen.push(dobj)
    let jsonData=JSON.parse(data_val.json_value)
    let lineData=[]
    let data_type=""
    let parameter=""
    jsonData.map((value)=>{
      lineData.push(
        {
          y: (value.actual_value===null?0:value.actual_value),
          marker: value.week_ending===value.date?{ 
            enabled:true
           }:{
            enabled:true,
            radius:3,
            lineWidth: 1,
           },
          x:  new Date(value.date).getTime(),
          enableShow: value.week_ending===value.date?true:false ,
        } 
        )
      data_type=value.data_type
      parameter=value.parameter
    })
    let obj={
      "disease_id": data_type,
      "season": parameter,
      "geo_type": geo_id,
      "json_value": lineData
    }
    pollenChartData.push(obj)
  }
  
  
})
//For AQI Public Data Trend Chart

    return(
        getAllergyData!==undefined&&
        getStaticData!==undefined&&
        getAqiPublicData!==undefined&&
        !isAlLoading&&!isAqLoading
         && (<TrendCharts 
            chartData={chartData}
            dataCategory={dataCategory}
            pollutantChartData={pollutantChartData}
            pollenChartData={pollenChartData}
            dataCategoryPollen={dataCategoryPollen}
            dataCategoryPollutant={dataCategoryPollutant}
            geo_type={geo_type} 
            geo_id={geo_id} 
            data_type={data_type} />)
    ) 
}
export default TrendChart